export { default } from './ServiceAdd'


// WEBPACK FOOTER //
// ./src/scenes/Administration/Service/ServiceAdd/index.js